module.exports = __webpack_public_path__ + "img/icon.9ffca6fe.png";